// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5116":"a97a1868","5494":"a97a1868","6046":"996df3dc"}[chunkId] + ".chunk.css";
};